'use client'

import { useState, useEffect } from 'react'
import styles from './TerminalTabs.module.css'

interface Portfolio {
  symbol: string
  shares: number
  industry: string
  avgPrice: number
  currentPrice: number
  pnl: number
}

export default function Holdings() {
  const [portfolio, setPortfolio] = useState<Portfolio[]>([])
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    const fetchPortfolio = async () => {
      setIsLoading(true)
      try {
        const response = await fetch('/api/portfolio')
        if (!response.ok) throw new Error('Failed to fetch portfolio')
        const data = await response.json()
        setPortfolio(data.portfolio)
      } catch (error) {
        console.error('Error fetching portfolio:', error)
      } finally {
        setIsLoading(false)
      }
    }

    fetchPortfolio()
  }, [])

  if (isLoading) return <div>Loading holdings...</div>
  if (portfolio.length === 0) return <div>No holdings found</div>

  const totalPnL = portfolio.reduce((sum, holding) => sum + holding.pnl, 0)
  const totalValue = portfolio.reduce(
    (sum, holding) => sum + holding.currentPrice * holding.shares,
    0
  )

  return (
    <div className={styles.holdingsContainer}>
      <div className={styles.holdingsSummary}>
        <div className={styles.summaryCard}>
          <h3>Total Portfolio Value</h3>
          <p>₹{totalValue.toLocaleString()}</p>
        </div>
        <div className={styles.summaryCard}>
          <h3>Total P&L</h3>
          <p className={totalPnL >= 0 ? styles.profit : styles.loss}>
            ₹{totalPnL.toLocaleString()}
          </p>
        </div>
      </div>
      <div className={styles.holdingsTable}>
        <table>
          <thead>
            <tr>
              <th>Symbol</th>
              <th>Industry</th>
              <th>Shares</th>
              <th>Avg Price</th>
              <th>Current Price</th>
              <th>Current Value</th>
              <th>P&L</th>
              <th>P&L %</th>
            </tr>
          </thead>
          <tbody>
            {portfolio.map(holding => {
              const currentValue = holding.currentPrice * holding.shares
              const pnlPercentage =
                (holding.pnl / (holding.avgPrice * holding.shares)) * 100
              return (
                <tr key={holding.symbol}>
                  <td>{holding.symbol}</td>
                  <td>{holding.industry}</td>
                  <td>{holding.shares}</td>
                  <td>₹{holding.avgPrice}</td>
                  <td>₹{holding.currentPrice}</td>
                  <td>₹{currentValue.toLocaleString()}</td>
                  <td
                    className={holding.pnl >= 0 ? styles.profit : styles.loss}
                  >
                    ₹{holding.pnl.toLocaleString()}
                  </td>
                  <td
                    className={holding.pnl >= 0 ? styles.profit : styles.loss}
                  >
                    {pnlPercentage.toFixed(2)}%
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </div>
  )
}
